import styled from 'styled-components';
import colors from 'Styles/colors';

export const Label = styled.div`
  font-size: 12.5px;
  font-weight: normal;
  letter-spacing: 0.09px;
  color: ${({ theme }) => theme.text.runAgentInputLabel};
  margin-left: 10px;
`;
Label.displayName = 'Label';

export const CheckboxWrapper = styled.div`
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  user-select: none;

  &[required] {
    ${Label}::after {
      content: ' *';
      color: ${colors.redPink};
    }
  }
`;
CheckboxWrapper.displayName = 'FieldWrapper';
